import React from 'react';

const LoginIcon = () => {
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="30" height="30" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M2370 5105 c-407 -57 -759 -292 -979 -654 -154 -254 -220 -581 -175
-878 50 -342 219 -644 479 -860 45 -37 48 -42 30 -49 -392 -142 -680 -318
-963 -590 -353 -338 -598 -757 -724 -1238 -44 -166 -45 -304 -5 -419 65 -185
197 -319 380 -385 l72 -26 435 -4 435 -3 44 23 c25 13 59 40 75 61 29 36 31
45 31 117 0 72 -2 81 -31 117 -16 21 -50 48 -74 60 -44 23 -50 23 -430 23
-251 0 -399 4 -425 11 -76 21 -145 115 -145 197 0 35 47 214 86 327 70 202
214 461 353 635 222 277 544 521 871 658 290 121 521 166 850 166 286 0 431
-22 702 -110 119 -38 161 -41 216 -19 76 32 122 102 122 185 0 94 -54 164
-152 195 -29 10 -57 21 -61 25 -4 4 18 28 50 54 32 27 91 84 131 129 484 535
463 1356 -48 1867 -303 303 -726 444 -1150 385z m373 -406 c193 -39 354 -125
493 -263 139 -140 224 -299 264 -496 65 -313 -46 -655 -285 -878 -143 -134
-301 -212 -500 -247 -199 -34 -403 -3 -590 92 -309 157 -505 464 -522 818 -12
262 90 519 281 711 230 229 548 327 859 263z"/>
<path d="M3712 1970 c-101 -27 -166 -64 -242 -140 -66 -65 -82 -91 -130 -210
l-27 -65 -684 -5 c-614 -4 -687 -7 -714 -22 -50 -27 -415 -406 -436 -452 -22
-50 -24 -105 -4 -152 17 -41 359 -401 425 -448 l45 -31 390 0 390 0 38 24 c21
13 50 42 65 64 23 34 27 52 27 107 0 55 -4 73 -27 107 -15 22 -44 51 -65 64
-38 24 -41 24 -353 27 l-315 3 -77 76 -77 76 72 79 71 78 710 0 c698 0 710 0
753 21 66 32 88 66 132 207 42 135 64 173 111 197 42 22 694 22 745 1 42 -18
65 -54 106 -166 70 -194 94 -401 65 -570 -23 -130 -62 -264 -99 -341 -51 -102
-39 -99 -445 -99 -234 0 -350 4 -365 11 -58 30 -77 62 -119 194 -22 71 -51
144 -64 161 -66 88 -213 95 -294 14 -51 -51 -67 -113 -51 -193 18 -87 68 -233
104 -302 43 -82 147 -184 230 -225 112 -55 154 -59 553 -60 398 0 441 4 552
56 96 44 203 149 250 246 43 88 106 282 133 410 30 140 33 397 5 543 -33 177
-108 392 -170 488 -46 72 -139 155 -215 190 -111 52 -152 56 -556 56 -332 0
-378 -2 -443 -19z"/>
<path d="M4242 1189 c-48 -14 -109 -80 -123 -131 -23 -89 12 -182 88 -229 57
-36 154 -34 210 3 62 41 88 90 88 168 0 77 -26 127 -85 166 -43 29 -125 39
-178 23z"/>
</g>
</svg>
  );
};

export default LoginIcon;
